// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-Page__DomainSettings .domain-settings {
  min-height: fit-content;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background-color: #ffffff;
  border-radius: 8px;
}

.BC-Page__DomainSettings .domain-settings .notify-warning {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 6px;
  color: #916a00;
}
.BC-Page__DomainSettings .domain-settings .notify-success {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 6px;
  color: #008060;
}

.BC-Page__DomainSettings .domain-settings .notify-warning .Polaris-Icon,
.BC-Page__DomainSettings .domain-settings .notify-success .Polaris-Icon {
  margin: unset;
  width: 16px;
  height: 16px;
}

.BC-Page__DomainSettings .domain-settings > div {
  background-color: #fafbfb;
  padding: 12px 16px;
}

.BC-Page__DomainSettings .domain-settings .pfs-feature-lock-card {
  background-color: #ffffff;
}

.BC-Page__DomainSettings .domain-settings .domain-field {
  display: flex;
  gap: 16px;
  align-items: start;
}

.BC-Page__DomainSettings .domain-settings .domain-field .action {
  display: flex;
}

.BC-Page__DomainSettings .domain-settings .domain-field > div:first-child {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/styles/domain-settings.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb","sourcesContent":[".BC-Page__DomainSettings .domain-settings {\n  min-height: fit-content;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px;\n  background-color: #ffffff;\n  border-radius: 8px;\n}\n\n.BC-Page__DomainSettings .domain-settings .notify-warning {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding-top: 6px;\n  color: #916a00;\n}\n.BC-Page__DomainSettings .domain-settings .notify-success {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding-top: 6px;\n  color: #008060;\n}\n\n.BC-Page__DomainSettings .domain-settings .notify-warning .Polaris-Icon,\n.BC-Page__DomainSettings .domain-settings .notify-success .Polaris-Icon {\n  margin: unset;\n  width: 16px;\n  height: 16px;\n}\n\n.BC-Page__DomainSettings .domain-settings > div {\n  background-color: #fafbfb;\n  padding: 12px 16px;\n}\n\n.BC-Page__DomainSettings .domain-settings .pfs-feature-lock-card {\n  background-color: #ffffff;\n}\n\n.BC-Page__DomainSettings .domain-settings .domain-field {\n  display: flex;\n  gap: 16px;\n  align-items: start;\n}\n\n.BC-Page__DomainSettings .domain-settings .domain-field .action {\n  display: flex;\n}\n\n.BC-Page__DomainSettings .domain-settings .domain-field > div:first-child {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
